import React, { useEffect } from 'react';
import axios from '../../../Helpers/Axiosbase'
import { Card, CardHeader, CardContent, TextField, Button, Switch, FormGroup, FormControlLabel,CardActions } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress,Snackbar } from '@material-ui/core';
import { useInputChange } from '../../../Helpers/useInputChange'
import * as actions from '../../../Store/Actions'
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(2),
            width: 250,
        }
    }
}));

export default function EnvironmentManage(props) {
    const [showProgress, setShowProgress] = React.useState(false);
    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const { location, history } = useReactRouter();


    const [input, handleInputChange, handleSwitchChange, setInput] = useInputChange({
        displayName: "",
        tenantId: "",
        webURL: "",
        rsAPIUser: "",
        authClientId: "",
        authClientSecret: "",
        isActive: true
    });
    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
      };

    const onCancleClickHandler = () =>{
        history.push("/environment")
    }

    var onSubmitClickHandler = () => {
        // let url=input.webURL+input.tenantId+"/api/entitymodelservice/get";
        // console.log(url);
        // let body="{\"params\": {\"query\": {\"contexts\": [],\"filters\": {\"typesCriterion\": [\"user\"],\"nonContextual\": \"false\"}},\"fields\": {\"attributes\": [\"_ALL\"]},\"options\": {\"maxRecords\": 2000}}}";
        // // let body={ 
        // //     "params": {
        // //       "query": { 
        // //         "filters" : {
        // //           "typesCriterion": [
        // //           "user"
        // //           ]
        // //         }
        // //       }
        // //     }
        // //   }
        //   console.log(body);
        // axios.post(url,body,{
        //     headers: {
        //       'Content-Type': 'application/json',
        //     //   'Access-Control-Allow-Origin':'http://localhost:3000',
        //     //   'Access-Control-Allow-Credentials':'true',
        //     //   'Access-Control-Allow-Methods' : 'GET, POST, OPTIONS',
        //       'auth-client-id':input.authClientId,
        //       'auth-client-secret':input.authClientSecret,
        //       'x-rdp-tenantId':input.tenantId,
        //       'x-rdp-userId':input.userId,
        //       'x-rdp-clientId':"rdpclient",
        //      'x-rdp-userRoles': "[\"systemadmin\"]",
        //      'x-rdp-version': "8.1"
        //     }
        //   })
        //     .then(response => {
        //         console.log(response);
        //         // history.push('/environment');
        //     })
        //     .catch(err => {
        //         console.log(err);
        //         if (err.response.status === 403) {
        //             // setShowProgress(false);
        //             dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
        //         }
        //     });
        setShowProgress(true);
        // console.log(input);
        let url = ""
        url = input._id ? "environmentUpdate" : "environmentCreate";
        axios.post(url, { ...input, token: reduxAuth.token, userId: reduxAuth.userId })
            .then(response => {
                history.push('/environment');
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                }
            }
            });
    }

    useEffect(() => {
        if (location.state) {
            setInput(location.state);
        }
    }, []);

    const classes = useStyles();

    return (
        <div>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {showProgress ? <LinearProgress /> : null}
            <Card>
                <CardHeader title="Manage Environment" />
                <CardContent >
                    <form className={classes.root}>
                        <div>
                            <TextField name="displayName" id="displayName" label="Display Name" onChange={(event) => handleInputChange(event)} value={input.displayName} />
                            <TextField name="tenantId" id="tenantId" label="Tenant ID" onChange={(event) => handleInputChange(event)} value={input.tenantId} />
                            <TextField name="webURL" id="webURL" label="Web URL" onChange={(event) => handleInputChange(event)} value={input.webURL} />
                            <TextField name="rsAPIUser" id="rsAPIUser" label="API User" onChange={(event) => handleInputChange(event)} value={input.rsAPIUser} />
                            <TextField name="authClientId" id="authClientId" label="Auth Client ID" onChange={(event) => handleInputChange(event)} value={input.authClientId} />
                            <TextField name="authClientSecret" id="authClientSecret" label="Auth Client Secret" onChange={(event) => handleInputChange(event)} value={input.authClientSecret} />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch name="isActive" checked={input.isActive}
                                        onChange={() => handleSwitchChange('isActive')} color="primary" />
                                    }
                                    label="Is Active?" />
                            </FormGroup>
                        <CardActions>
                            <Button color="primary" variant="contained" onClick={onSubmitClickHandler}>Submit</Button>
                            <Button color="secondary" variant="contained" onClick={onCancleClickHandler}>Cancle</Button>
                        </CardActions>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}